<template>
  <div>
    <b-row>

      <b-col cols="6" xl="4">
        <label>{{ $t('columns.company') }}</label>
        <b-form-input v-model="affiliate.company"/>
      </b-col>

      <b-col cols="6" xl="4">
        <label>{{ $t('columns.alias') }}</label>
        <b-form-input v-model="affiliate.alias"/>
      </b-col>


      <b-col cols="6" xl="4">
        <label>{{ $t('columns.email') }}</label>
        <b-input-group>
          <b-form-input v-model="affiliate.email"/>
        </b-input-group>
      </b-col>
      <b-col cols="6" xl="4">
        <label>{{ $t('columns.skype') }}</label>
        <b-input-group>
          <b-form-input v-model="affiliate.skype"/>
        </b-input-group>
      </b-col>

      <b-col cols="4" xl="3" >
        <label>{{ $t('defaultClientStatus') }}</label>
        <client-status-picker v-model="affiliate.clientStatusId" auto-init/>
      </b-col>

      <b-col cols="2" xl="2">
        <label class="invisible">{{ $t('columns.active') }}</label>
        <b-checkbox switch v-model="affiliate.unforceClientDuplicate">{{ $t('columns.unforceClientDuplicate') }}</b-checkbox>
      </b-col>
      <b-col cols="2" xl="2">
        <b-button block class="mt-2 d-inline-block" variant="outline-primary" @click="save">{{ $t('operations.save') }}
        </b-button>
      </b-col>

    </b-row>

    <email-editor-modal @emailTemplateSaved="sendEmail" ref="emailEditorModal" :receiver="affiliate"
    ></email-editor-modal>

  </div>
</template>

<script>
import Affiliate from '@/model/affiliate/Affiliate';
import mixinPermissions from '@/components/mixin/mixinPermissions';
import { mapActions, mapGetters } from 'vuex';
import mixinNotifications from '@/components/mixin/mixinNotifications';
import OrganizationSelectBox from '@/components/widget/select/OrganizationSelectBox';
import BusinessUnitSelectBox from '@/components/widget/select/BusinessUnitSelectBox';
import CountriesSelectBox from '@/components/widget/select/CountriesSelectBox';
import CalendarPicker from '@/components/widget/picker/calendarPicker';
import mixinBase from '@/components/mixin/mixinBase';
import EmailEditorModal from '@/components/partial/mailTemplates/EmailEditorModal';
import AffiliateTokenTable from '@/components/tables/AffiliateTokenTable.vue';
import ClientStatusPicker from '@/components/widget/picker/clientStatusPicker.vue'

export default {
  name: 'AffiliateEditDetails',
  components: {
    ClientStatusPicker,
    AffiliateTokenTable,
    EmailEditorModal,
    CalendarPicker,
    CountriesSelectBox,
    BusinessUnitSelectBox,
    OrganizationSelectBox
  },
  mixins: [mixinPermissions, mixinNotifications, mixinBase],
  data: () => ({
    affiliate: Affiliate(),
    tokens: [],
  }),
  props: {
    value: {
      required: true,
      default: () => ({})
    },
    newAffiliate: {
      type: Boolean,
      default: () => false
    }
  },
  watch: {
    value: {
      handler() {
        this.affiliate = Object.assign(Affiliate(), this.value);
      },
      immediate: true
    }
  },
  created() {
  },
  computed: {
    ...mapGetters('affiliate', [''])
  },
  methods: {
    ...mapActions('affiliate', ['getAffiliateTokens', 'updateAffiliate', 'createAffiliate']),
    openEmailEditor() {
      // Show the email editor modal
      this.$refs.emailEditorModal.showModal = true;
    },
    sendEmail() {
      this.$refs.emailEditorModal.showModal = false;
    },
    updateAffiliateTokens() {
      this.tokens = [];
      this.getAffiliateTokens({ id: this.affiliate.id })
          .then(response => {
            this.tokens = response.data;
          });
    },
    async addAffiliate() {
      let $this = this;
      try {
        let affiliate = await this.createAffiliate({
          affiliate: this.affiliate,
        });
        this.showSuccessNotification($this.$t('globalMessages.addDataSuccess', { system: $this.$t('menu.affiliates') }));
        this.$emit('input', affiliate);
        this.$emit('updated', affiliate.id);
        this.$emit('submitted', affiliate);
        this.refreshTables();
      } catch (err) {
        $this.showServerErrorNotification('addDataError', 'affiliates', err);
      }
    }
    ,

    async modifyAffiliate() {
      let $this = this;
      try {
        let affiliate = await this.updateAffiliate({
          affiliate: this.affiliate,
          id: this.affiliate.id

        });

        this.showSuccessNotification($this.$t('globalMessages.updateDataSuccess', { system: $this.$t('menu.affiliates') }));
        this.$emit('input', affiliate);
        this.$emit('updated', affiliate.id);
        this.refreshTables();
      } catch (err) {
        $this.showServerErrorNotification('addDataError', 'affiliates', err);
      }

    },

    async save() {
      if (this.affiliate.id == null) {
        await this.addAffiliate();
      } else {
        await this.modifyAffiliate();
      }
    }
  }
};
</script>

<style scoped>
.table-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 1rem;
}

.add-button {
  margin-left: 1rem;
}
</style>
